(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-carrusel-tiktok-gemini"] && !Shopify.designMode) return;
  try {
    
  class SocialCarousel extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.social-slider');
      if (!this.slider) return;

      this.isAutoScroll = this.getAttribute('data-auto-scroll') === 'true';
      this.direction = this.getAttribute('data-direction');
      this.speed = parseFloat(this.getAttribute('data-speed'));
      
      this.isPaused = false;
      this.scrollPos = 0;
      this.maxScroll = 0;

      if (this.isAutoScroll && this.slider.children.length > 0) {
        this.initInfiniteScroll();
        this.bindEvents();
      }
    }

    initInfiniteScroll() {
      // Clona el contenido para crear un bucle infinito real
      const originalContent = this.slider.innerHTML;
      this.slider.innerHTML += originalContent;

      // Un pequeño retraso para asegurar que las imágenes/videos rendericen y calculen su ancho
      setTimeout(() => {
        this.maxScroll = this.slider.scrollWidth / 2;
        
        if (this.direction === 'right') {
          this.scrollPos = this.maxScroll;
          this.slider.scrollLeft = this.scrollPos;
        }
        
        this.animate();
      }, 200);
    }

    bindEvents() {
      // Función para pausar el carrusel
      const pause = () => { this.isPaused = true; };
      // Función para reanudar el carrusel
      const resume = () => { this.isPaused = false; };

      // Controles para PC (Hover y Clic)
      this.slider.addEventListener('mouseenter', pause);
      this.slider.addEventListener('mouseleave', resume);
      this.slider.addEventListener('mousedown', pause);
      this.slider.addEventListener('mouseup', resume);

      // Controles para Celular (Mantener presionado)
      this.slider.addEventListener('touchstart', pause, { passive: true });
      this.slider.addEventListener('touchend', resume, { passive: true });
    }

    animate() {
      if (!this.isPaused) {
        // Calcular la nueva posición basada en la dirección
        if (this.direction === 'left') {
          this.scrollPos += this.speed;
          if (this.scrollPos >= this.maxScroll) {
            this.scrollPos -= this.maxScroll; // Reseteo imperceptible
          }
        } else {
          this.scrollPos -= this.speed;
          if (this.scrollPos <= 0) {
            this.scrollPos += this.maxScroll; // Reseteo imperceptible
          }
        }
        
        // Aplicar el movimiento fluido
        this.slider.scrollLeft = this.scrollPos;
      }
      
      // Llamar al siguiente frame de animación
      requestAnimationFrame(this.animate.bind(this));
    }
  }

  if (!customElements.get('social-carousel')) {
    customElements.define('social-carousel', SocialCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
